export const EditProductsSteps = [
    {
        target: '.custom-field-item-name',
        disableScrolling: true,
        placementBeacon: "top",
        content: 'Edit the name of the product here.',
    },
    //MuiTab-fullWidth Mui-selected
    {
        target: '.MuiTab-root:nth-child(1)',
        content: 'Find more details about the product on these tabs, here you can se Supplier Products',
        
    },
    {
        target: '.MuiTab-root:nth-child(2)',
        spotlightClicks: true,
        content: 'Click here to see related Sales Items',
        
    }
    , {
        target: ".custom-button-save",
        content:"No changes are saved until you press the Save button"
        
    }


]